import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { ServicesHelper } from '../helpers/services.helper';
import { Observable } from 'rxjs';
import { PermissionType } from '../enums';

@Injectable()
export class PermissionService {
  private url: string;
  constructor(private httpClient: HttpClient, @Inject('API_URL') private apiUrl: string) {
    this.url = apiUrl + 'permission/';
  }

  getPermissions(): Observable<Array<PermissionType>> {
    const url: string = this.url + 'user';
    const response: Observable<Array<PermissionType>> = this.httpClient.get<Array<PermissionType>>(url);
    return response;
  }
  
}
